'use strict';

import {detect} from 'detect-browser';
import "./heroSlide.js";

((Drupal, $) => {

  // Fix the context button when inside the button paragraph.
  Drupal.behaviors.CjdParagraphLinkButtonBehavior = {
    attach(context) {

      $('a.paragraph--type--button').on('click', 'button', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }

  };

})(Drupal, jQuery);


let browser_detect = () => {

  const browser = detect();

// handle the case where we don't detect the browser
  if (browser) {
    document.body.classList.add(`browser-${browser.name}`)
  }
}

window.addEventListener('load', browser_detect);
window.addEventListener('load', () => {
  window.setTimeout(() => {
    let readspeaker = document.querySelector('.block-open-readspeaker-webreader');

    if (!readspeaker) {
      return;
    }

    readspeaker.style.visibility = "initial";
  }, 100)
});

let fundraising = () => {
  let fundraising_hero = document.querySelector('.paragraph--type--hero-fundraising');

  if (!fundraising_hero) {
    return;
  }

  // Logic for button sum.
  let trigger_btns = fundraising_hero.querySelectorAll('.btn');
  trigger_btns.forEach(button => {
    button.addEventListener('click', () => {
      let activeButton = button.parentElement.querySelector('.white');
      if (activeButton) {
        activeButton.classList.remove('white');
      }

      let donation_sum = button.getAttribute('data-donation-sum');

      if (!donation_sum) {
        return;
      }

      let link = fundraising_hero.querySelector('a');
      let base_url = link.getAttribute('data-base-url');

      if (!base_url) {
        return;
      }

      let params = new URLSearchParams();
      params.set('tw_amount', donation_sum);
      button.classList.add('white');
      link.href = `${base_url}?${params.toString()}`;
    });
  });
}

window.addEventListener('load', fundraising);


let donate_teaser = () => {

  let donate_teaser_block = document.querySelector('.node--type--offer .block-offer-donation-banner');

  if (!donate_teaser_block) {
    return;
  }

  let donate_teaser_block_button = donate_teaser_block.querySelector('.donation-info-wrapper a.btn');

  donate_teaser_block_button.addEventListener('click', () => {
    let offer_title = document.querySelector('.block-page-title-block h1 span').textContent;
    localStorage.setItem('offer-title', offer_title);
  })

}
window.addEventListener('load', donate_teaser);

let offer_iframe = () => {
  let donate_iframe = document.querySelector('.paragraph--type--html-snippets iframe[id*="twingle"]');

  if (donate_iframe === null) {
    return;
  }

  donate_iframe = donate_iframe.getAttribute('id');

  function sendDataToIframe(iframeId, dataToSend = {}) {
    const iframe = document.querySelector(`#${donate_iframe}`);

    if (iframe) {
      iframe.contentWindow.postMessage(
        {
          type: 'setGuideData',
          value: dataToSend,
        },
        '*'
      );
    }
  }

  sendDataToIframe(`#${donate_iframe}`, {name: localStorage.getItem('offer-title')});
  donate_iframe.contentWindow.postMessage({type: 'clearGuideData'}, '*');

}

window.addEventListener('load', offer_iframe);
